import React, { FunctionComponent, ReactElement } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import styled from 'styled-components/native'

// eslint-disable-next-line local-rules/no-theme-from-theme
import { theme } from 'theme'
import { ArrowNext } from 'ui/svg/icons/ArrowNext'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { getSpacing } from 'ui/theme'

type GenericBannerProps = {
  LeftIcon?: ReactElement
  RightIcon?: FunctionComponent<AccessibleIcon>
  noRightIcon?: boolean
  children: React.ReactNode
  style?: StyleProp<ViewStyle>
  testID?: string
}

export const GenericBanner: FunctionComponent<GenericBannerProps> = ({
  LeftIcon,
  RightIcon,
  noRightIcon = false,
  style,
  children,
  testID,
}) => {
  return (
    <View style={[styles.container, style]} testID={testID}>
      {LeftIcon ? <IconContainer>{LeftIcon}</IconContainer> : null}
      <DescriptionContainer>{children}</DescriptionContainer>
      {noRightIcon ? null : <View>{RightIcon ? <RightIcon /> : <StyledArrowNextIcon />}</View>}
    </View>
  )
}

const StyledArrowNextIcon = styled(ArrowNext).attrs(({ theme }) => ({
  size: theme.designSystem.size.icon.m,
  color: theme.designSystem.color.icon.default,
}))``

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderStyle: 'solid',
    borderWidth: getSpacing(0.25),
    borderRadius: theme.designSystem.size.borderRadius.m,
    borderColor: theme.designSystem.color.border.default,
    padding: theme.designSystem.size.spacing.l,
    width: '100%',
  },
})

const DescriptionContainer = styled.View(({ theme }) => ({
  flexShrink: 1,
  flexGrow: 1,
  marginRight: theme.designSystem.size.spacing.l,
  textAlign: 'start',
}))

const IconContainer = styled.View(({ theme }) => ({
  alignContent: 'center',
  marginRight: theme.designSystem.size.spacing.l,
}))
